var _g, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalStatsPerm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21113_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.222656,
    width: 66.4391,
    height: 66.3462,
    rx: 10,
    fill: "#E4E7F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.549 47.5943H20.1174C19.3525 47.5943 18.7266 46.9692 18.7266 46.2053C18.7266 45.4414 19.3525 44.8164 20.1174 44.8164H30.549C31.314 44.8164 31.9399 45.4414 31.9399 46.2053C31.9399 46.9692 31.314 47.5943 30.549 47.5943Z",
    fill: "#8D98B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.1988 54.5396H20.1174C19.3525 54.5396 18.7266 53.9146 18.7266 53.1506C18.7266 52.3867 19.3525 51.7617 20.1174 51.7617H38.1988C38.9638 51.7617 39.5897 52.3867 39.5897 53.1506C39.5897 53.9146 38.9638 54.5396 38.1988 54.5396Z",
    fill: "#8D98B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.446 23.1549C33.1418 23.1549 33.7258 23.7291 33.6195 24.4163C32.9953 28.4588 29.5346 31.4603 25.3607 31.4603C20.7429 31.4603 17 27.7174 17 23.1006C17 19.2969 19.8897 15.7537 23.143 14.9526C23.8421 14.78 24.5585 15.2718 24.5585 15.9915C24.5585 20.8677 24.7225 22.1291 25.6484 22.8151C26.5744 23.5012 27.6632 23.1549 32.446 23.1549Z",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9982 18.097C38.0536 14.9641 34.2054 9.91426 29.5159 10.0011C29.1512 10.0076 28.8592 10.3116 28.8429 10.6752C28.7245 13.2512 28.8841 16.5892 28.9731 18.1024C29.0003 18.5735 29.3704 18.9437 29.8405 18.9708C31.396 19.0598 34.8556 19.1814 37.3947 18.7971C37.7399 18.745 37.9928 18.4454 37.9982 18.097Z",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21113_85",
    x: -15.7773,
    y: -16,
    width: 98.4375,
    height: 98.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21113_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21113_85",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStatsPerm);
export default __webpack_public_path__ + "static/media/total-stats-perm.9a63c404.svg";
export { ForwardRef as ReactComponent };